import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { ListItemDiv } from '@wix/da-ds/pkg/List/ListItem';
import GallectionCover from '../GallectionCover';
const GallectionListItemDiv = (_param)=>{
    var { gallection, onChange } = _param, rest = _object_without_properties(_param, [
        "gallection",
        "onChange"
    ]);
    return /*#__PURE__*/ React.createElement(ListItemDiv, _object_spread({
        label: gallection.name,
        prefix: /*#__PURE__*/ React.createElement(GallectionCover, {
            gallection: gallection
        }),
        fillContainerWidth: true,
        onChange: onChange && ((isSelectedNew)=>onChange({
                folderId: gallection.folderId,
                isSelected: !!isSelectedNew
            }))
    }, rest));
};
GallectionListItemDiv.displayName = 'GallectionListItemDiv';
export default GallectionListItemDiv;
